/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type ListDatasetRowVersionsPathParams = NonNullable<operations['listDatasetRowVersions']['parameters']['path']>;

export type ListDatasetRowVersionsQueryParams = NonNullable<
  operations['listDatasetRowVersions']['parameters']['query']
>;

export interface Input extends ListDatasetRowVersionsPathParams {
  apiVersion?: string;
  query?: ListDatasetRowVersionsQueryParams;
}

export async function listDatasetRowVersions(
  { apiVersion, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/internal/projects/{projKey}/datasets/{datasetId}/rows/versions', {
    params: { path, query },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
